import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMacbook: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMacbook"><Path d="M23 21H1V16H23V21Z" fill="currentColor"/><Path d="M21 14H3V3H21V14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMacbook;
